import { useMemo } from 'react';

import { FormattedJob } from 'types';

import { useCurrentJob } from '../../hooks';

export interface ContainerComponentChildrenArgs {
  job?: FormattedJob;
  isLoading: boolean;
  showLineItems: boolean;
}

export interface ContainerComponentProps {
  children: (args: ContainerComponentChildrenArgs) => JSX.Element;
}

const ContainerComponent = ({ children }: ContainerComponentProps) => {
  const { job, isLoading } = useCurrentJob();

  const showLineItems = useMemo(() => {
    if (!job) return true;
    const checkoutOptions = job?.checkout_options;
    if (checkoutOptions?.includes('apply_for_finance')) return true;
    return false;
  }, [job]);

  return children({
    job,
    isLoading,
    showLineItems,
  });
};

ContainerComponent.displayName = 'JobSidebar-container';

export default ContainerComponent;
